import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import FadeIn from "react-fade-in/lib/FadeIn";
import {
  getChildrens,
  getRoles,
  getUserSettings,
} from "../../../../services/api";
import {
  Dispatch,
  ReactNode,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from "react";
import ReccuringTree from "./recurringTree";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { actionCreators, RootState } from "../../../../store";
import { t } from "i18next";
import SearchBar from "../../../../atom/searchBar";
import { UserSettings } from "../../../../store/action-creators/auth.actions.creators";

export interface Children {
  childs: any[];
  uuid: string;
  type: string;
  status: string;
  name: string;
  display_name: string;
}

interface TenantTreeProps {
  activeAccount: string;
  setActiveAccount: Dispatch<SetStateAction<string>>;
  setShowModal: Dispatch<SetStateAction<boolean>>;
}

const TenantTree: React.FC<TenantTreeProps> = ({
  activeAccount,
  setActiveAccount,
  setShowModal,
}) => {
  const [data, setData] = useState<Children[]>([]);
  const searchRef = useRef("");
  const dataRef = useRef<Children[]>([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleTenantData = (payload: any) => {
    getChildrens(payload, true)
      .then((result: any) => {
        setData([...result]);
        dataRef.current = [...result];
      })
      .catch((error) => {});
  };
  const { token } = useSelector((state: RootState) => state?.Auth);

  const hanldeTreeClick = (
    node: Record<string, any> = {},
    mode: string = ""
  ) => {
    const isEmptyNode = Object.keys(node).length === 0;
    const payload = {
      name: isEmptyNode ? "super_admin" : `${node.type}_admin`,
    };

    // Set the active account
    const accountName = isEmptyNode
      ? token?.azp
      : node?.display_name || node?.name;
    setActiveAccount(accountName);

    // Fetch user settings
    const userSettingsParams = isEmptyNode
      ? undefined
      : { admin_id: node?.uuid };
    getUserSettings(token?.sub ?? "", userSettingsParams).then(
      (result: UserSettings) => {
        dispatch(actionCreators.SetAppsList(result?.apps));
        dispatch(actionCreators.SetUserSettings(result));
      }
    );

    // Update local storage with the current account
    localStorage.setItem(
      "currentAccount",
      JSON.stringify(isEmptyNode ? token : node)
    );

    // Reset reports state and update roles
    dispatch(actionCreators.setReportsState(""));
    getRoles(payload).then((result) => {
      dispatch(actionCreators.setUserRoles(result));
    });

    // Navigate and close modal
    navigate(`/bvoice/home`, { replace: true });
    setShowModal(false);

    console.log("Node processed:", payload);
  };

  useEffect(() => {
    handleTenantData({});
  }, []);

  const onHandleClose = async () => {
    console.log("pop", searchRef?.current);
    setData([...dataRef?.current]);
  };

  const handleSearch = async () => {
    console.log("popSearch", searchRef?.current);
    let copyData = [...data];
    copyData = copyData?.filter(
      (node: Children) =>
        (node?.display_name &&
          node?.display_name
            .trim()
            .toLowerCase()
            .includes(searchRef?.current)) ||
        (node?.name &&
          node?.name.trim().toLowerCase().includes(searchRef?.current)) ||
        node?.childs?.filter(
          (Children: Children) =>
            Children?.display_name
              ?.trim()
              .toLowerCase()
              .includes(searchRef?.current) ||
            Children?.name?.trim().toLowerCase().includes(searchRef?.current)
        )?.length !== 0
    );

    setData(copyData);
  };

  console.log("activeAccount", activeAccount, dataRef?.current);
  return (
    <div className="bg-primary-alpha-5 bg-opacity-100  backdrop-blur fixed inset-0 z-50">
      <div className="w-full h-full">
        <FadeIn>
          <div className="absolute  top-0 right-0   mx-auto max-w-3xl w-11/12 sm:w-[440px] h-[100vh] bg-ternary text-ternary-text border-0 rounded-sm shadow-lg">
            <button
              className="p-1 ml-auto mr-5 border-0 text-[#000000] float-right text-3xl leading-none mt-4"
              onClick={() => setShowModal(false)}
            >
              <svg width="13" height="13" viewBox="0 0 10 10" fill="none">
                <path
                  d="M0.803125 9.98672L0.015625 9.19922L4.21562 4.99922L0.015625 0.799219L0.803125 0.0117188L5.00313 4.21172L9.20312 0.0117188L9.99062 0.799219L5.79063 4.99922L9.99062 9.19922L9.20312 9.98672L5.00313 5.78672L0.803125 9.98672Z"
                  fill="#A7A9AB"
                />
              </svg>
            </button>
            <TenantTreeTopBar>
              <SearchBar
                wrapperStyle="relative flex w-2/3 flex-wrap  sm:items-stretch"
                searchRef={searchRef}
                placeholder={t("Search")}
                handleEmptySearch={onHandleClose}
                handleSearch={handleSearch}
              />
            </TenantTreeTopBar>
            <ChildrenList
              search={searchRef?.current}
              accounts={data}
              hanldeTreeClick={hanldeTreeClick}
              activeAccount={activeAccount}
            />
          </div>
        </FadeIn>
      </div>
    </div>
  );
};
export default TenantTree;

const ChildrenList = ({
  accounts,
  activeAccount,
  hanldeTreeClick,
  search,
}: {
  accounts: Children[];
  search: string;
  activeAccount: string;
  hanldeTreeClick: (node: any, mode?: string) => void;
}) => {
  const filterChildren = (node: Children) => {
    return node?.childs?.filter(
      (Children: Children) =>
        Children?.display_name?.toLowerCase().includes(search) ||
        Children?.name?.toLowerCase().includes(search)
    );
  };

  return (
    <>
      <div
        onClick={() => hanldeTreeClick({}, "root")}
        className={`${activeAccount === "Supertelco" ? "text-primary" : "hover:text-primary pl-2"} py-2 pb-2  capitalize cursor-pointer  border-b  border-dotted border-primary-alpha-20 `}
      >
        <div className="absolute right-4">
          {activeAccount === "Supertelco" ? "Active" : ""}
        </div>
        <AdminPanelSettingsIcon /> {"Supertelco"}
      </div>
      <div className="pt-2 relative pl-4 overflow-y-auto h-[calc(100vh-48px)]">
        {accounts?.map((node: any, index: number) => {
          return (
            <div key={node.uuid} className="pt-2 pl-8">
              <div
                onClick={() => hanldeTreeClick(node)}
                className={`${activeAccount === node.name ? "text-primary" : "hover:text-primary"}  py-1 pb-2 capitalize cursor-pointer  border-b  border-dotted border-primary-alpha-20`}
              >
                <div className="absolute text-primary right-4">
                  {activeAccount?.toLowerCase().trim().split(" ").join("") ===
                  node?.display_name?.toLowerCase().trim().split(" ").join("")
                    ? "Active"
                    : ""}
                </div>
                {node.type === "telco" ? (
                  <AdminPanelSettingsIcon />
                ) : (
                  <ManageAccountsIcon />
                )}
                {node.display_name ? node.display_name : node.name}
              </div>

              {node?.childs && (
                <ReccuringTree
                  activeAccount={activeAccount}
                  hanldeTreeClick={hanldeTreeClick}
                  node={filterChildren(node)}
                />
              )}
            </div>
          );
        })}
      </div>
    </>
  );
};

const TenantTreeTopBar = ({ children }: { children: ReactNode }) => {
  return (
    <FadeIn>
      <div className="flex justify-between items-center px-5 py-3 rounded-t">
        Accounts List
        {children}
      </div>
      <hr />
    </FadeIn>
  );
};
